/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateMaterialDto } from '../models/CreateMaterialDto';
import type { UpdateMaterialDto } from '../models/UpdateMaterialDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MaterialsService {
    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static materialsControllerCreate(
        requestBody: CreateMaterialDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/materials',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all materials
     * @param page Page number
     * @param limit Items per page
     * @param searchName Search by material name
     * @returns any Returns all materials
     * @throws ApiError
     */
    public static materialsControllerFindAll(
        page?: number,
        limit?: number,
        searchName?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/materials',
            query: {
                'page': page,
                'limit': limit,
                'searchName': searchName,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static materialsControllerFindOne(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/materials/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static materialsControllerUpdate(
        id: string,
        requestBody: UpdateMaterialDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/materials/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a material
     * @param id
     * @returns any Material deleted successfully
     * @throws ApiError
     */
    public static materialsControllerRemove(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/materials/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Cannot delete material - it is being used by products`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Material not found`,
            },
        });
    }
}
